import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { NeedsHousehold } from '../common';
import TripsPage from './TripsPage';
import TripPage from './TripPage';
import PayTripPage from './PayTripPage';
import PutAwayPage from './PutAwayPage';

/** Pages under /casa/idas. */
const TripsRoutes: React.FC = () => (
  <NeedsHousehold>
    <Routes>
      <Route index element={<TripsPage />} />
      <Route path=":tripId" element={<TripPage />} />
      <Route path=":tripId/pagar" element={<PayTripPage />} />
      <Route path=":tripId/arrumar" element={<PutAwayPage />} />
    </Routes>
  </NeedsHousehold>
);

export default TripsRoutes;
